// Most of this scroll implementation is thanks to https://github.com/ReactTraining/react-router/issues/2019#issuecomment-297754072

import React, { Children } from 'react'

import { withRouter } from 'react-router'

import type { Location, RouterHistory } from 'react-router'

type PropTypes = {
  location: Location,
  history: RouterHistory,
  children: any
}

const PREFIX = '@@scroll/'

class ScrollHandler extends React.Component {
  props: PropTypes

  static locationVisited: {
    [key: string]: number
  } = {}

  constructor(props: PropTypes) {
    super(props)
    ;(this: any).onScroll = this.onScroll.bind(this)
  }

  componentDidMount() {
    //history.scrollRestoration = 'manual' // This call is currently causing an "Unexpected use of 'history' no-restricted-globals" error
    window.addEventListener('scroll', this.onScroll)
  }
  componentWillUnmount() {
    //history.scrollRestoration = 'auto' // This call is currently causing an "Unexpected use of 'history' no-restricted-globals" error
    window.removeEventListener('scroll', this.onScroll)
  }

  getLocationKey(key) {
    return PREFIX + (key || '')
  }

  onScroll() {
    requestAnimationFrame(() => {
      ScrollHandler.locationVisited[
        this.getLocationKey(this.props.location.key)
      ] =
        window.scrollY
    })
  }

  scrollTo(Y: number) {
    requestAnimationFrame(() => {
      window.scrollTo(0, Y)
    })
  }

  componentWillReceiveProps(nextProps) {
    const {
      location,
      history: { action }
    } = nextProps
    if (location !== this.props.location) {
      if (action === 'PUSH') {
        // New navigation, so scroll to top
        this.scrollTo(0, 0)
      } else {
        const key = this.getLocationKey(location.key)
        if (ScrollHandler.locationVisited.hasOwnProperty(key)) {
          const scrollY = ScrollHandler.locationVisited[key]
          this.scrollTo(scrollY)
        }
      }
    }
  }

  render() {
    return Children.only(this.props.children)
  }
}

export default withRouter(ScrollHandler)



// WEBPACK FOOTER //
// ./src/Components/ScrollHandler.js